export const keys = {
    ALPHAVANTAGE_API_KEY: "KUODQBYVCQNXXA9M",
    USERNAME: "bam",
    PASSWORD: "1155"
};